import { useGlobalContext } from '@prophecy/utils/react/utilify';
import { useMemo } from 'react';

import {
  UNSECURED_PDF_ANALYSIS_ENABLED_KEY,
  UNSECURED_UNIFIED_METRICS_ENABLED_KEY,
  UNSECURED_VERTICAL_APPS_ENABLED_KEY
} from './constants';

export const useUnsecuredGlobalVariables = () => {
  const globalContext = useGlobalContext();
  const settings = useMemo(
    () => (globalContext.unsecuredConfig || {}) as Record<string, unknown>,
    [globalContext.unsecuredConfig]
  );
  return useMemo(
    () => ({
      isConfigurableAuthEnabled:
        (settings['prophecy.ui.unsecured.configurableAuthOptions.enabled'] as boolean) ?? false,
      isSCIMEnabled: (settings['prophecy.ui.unsecured.scim.enabled'] as boolean) ?? false,
      isSaasSetup: (settings['prophecy.ui.unsecured.is_saas_setup.enabled'] as boolean) ?? false,
      isConfigurableUpdateEnabled: settings['prophecy.ui.unsecured.configurableUpdate.enabled'] ?? false,
      isMeteringEnabled: settings['prophecy.ui.unsecured.metering.enabled'] ?? false,
      isSignupEnabled: settings['prophecy.ui.unsecured.signup.enabled'] ?? true,
      isSMTPEnabled: settings['prophecy.ui.unsecured.smtp.enabled'] ?? true,
      isCrispChatEnabled: settings['prophecy.ui.unsecured.crispchat.enabled'] ?? false,
      getAccessURL: (settings['prophecy.ui.unsecured.getAccessURL'] as string) ?? '',
      isVerticalAppsEnabled: (settings[UNSECURED_VERTICAL_APPS_ENABLED_KEY] as boolean) ?? false,
      isPdfAnalysisEnabled: (settings[UNSECURED_PDF_ANALYSIS_ENABLED_KEY] as boolean) ?? false,
      isUnifiedMetricsEnabled: (settings[UNSECURED_UNIFIED_METRICS_ENABLED_KEY] as boolean) ?? false
    }),
    [settings]
  );
};
